import { connectionCloseHandler } from "../ConnectionCloseHandler";
import { connectWithSubscriptions } from "../ConnectWithSubscriptions";
import { connectionStore } from "../../Stores/ConnectionStore";
export function buildCloseHandler(connectionName, store) {
    return function (event) {
        let res = [false, -1];
        // code available only in debug builds is excluded from coverage
        /* istanbul ignore next */
        if (process.env.NODE_ENV === "development") {
            console.warn("Closed socket:", event);
        }
        const conn = connectionStore.get(connectionName);
        if (conn) {
            res = connectionCloseHandler(1000, connectWithSubscriptions.bind(undefined, conn, store), event);
        }
        return res;
    };
}
//# sourceMappingURL=BuildCloseHandler.js.map